import { useDispatch, useSelector } from "react-redux";
import DataTable from "../../common/components/DataTable";
import FilterView from "../../common/components/FilterView";
import { IDataTableColumn } from "../../common/types/dataTable";
import { AppDispatch, RootState } from "../template/store";
import { useEffect, useRef, useState } from "react";
import queryString from "query-string";
import { matchPath, useLocation, useParams, Link } from "react-router-dom";
import { AESDecrypt, AESEncrypt } from "../../../encrypt-util";
import { IConfigsDefinition } from "../../utils/columnConfig";
import { getColumnViews } from "../../common/actions/dataTable";
import {
  updateDashbaordRefresh,
  updateParams,
  updateSortStateDataTable,
} from "../../common/components/DataTable/slices/DataTable";
import { getDashboardData } from "../dashboard/actions/dashboard";
import { updateCurrentPageSez } from "../dashboard/slices/dashboardSlice";
import { updateDashbaordName } from "../../common/slices/navbarTop";
import moment from "moment";
import DashboardContainer from "../../../components/common/DashboardContainer";
import useDataCountry from "../../../hooks/useDataCountry";
import { toggleColumnSettingsSezDash } from "./SezSlice";
import { useGenerateColumnConfig } from "../../../hooks/useGenerateColumnConfig";
import { Button, Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faUpload } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import axios from "axios";
import UploadIndicator from "../../../components/common/UploadIndicator";
import { downloadSezInvoiceTemplate } from "./SezCertUpload";
import {
  getInvoiceUploadHistory,
  getSezRejectedMessage,
  uploadSezCertificateExcel,
} from "./SezActions";



const dashboardName = "SEZ_DASHBOARD";
const gridName = "sez_cert_req_detail";
const filterKey = "sezDashboard";
const defaultSort = "sez_cert_req_id desc";

const formatPendingSinceDays = (value: unknown) => {
  const trimmedValue = String(value ?? "").trim();
  if (!trimmedValue) return "0 days";

  const normalizedValue = trimmedValue.toLowerCase();
  if (normalizedValue.includes("day")) {
    return trimmedValue;
  }

  const numericValue = Number(trimmedValue);
  if (!Number.isNaN(numericValue)) {
    return `${numericValue} days`;
  }

  return trimmedValue;
};

interface ExcelUploadState {
  fileName: string;
  loadingProgress: number | null;
  uploadedFile: {
    fileName: string;
    serverFileName: string;
    serverFilePath: string;
  } | null;
  submitting: boolean;
}

const initialExcelUploadState: ExcelUploadState = {
  fileName: "Upload File",
  loadingProgress: null,
  uploadedFile: null,
  submitting: false,
};

const SezDashboard = () => {
  const { blid, bl_no, sez_cert_req_id } = useParams();
  const dispatch = useDispatch<AppDispatch>();
  const location = useLocation();
  const [columns, setColumns] = useState<IDataTableColumn[]>([]);
  const [configs, setConfigs] = useState<IConfigsDefinition>({
    columns: [],
    staticHiddenCols: [],
    defaultHiddenCols: [],
  });
  const refresh = useSelector((state: RootState) => state.dataTable.refreshDashboard);
  const currentPage = useSelector((state: RootState) => state.dashboard.currentPageSez);
  const data = useSelector((state: RootState) => state.dashboard.sezDashboardList);
  const dataLoading = useSelector((state: RootState) => state.dashboard.dataLoading);
  const filterState = useSelector((state: RootState) => state.dataTable.filterState);
  const grids = useSelector((state: RootState) => state.dataTable.sezGrids);

  const [previousState, setPreviousState] = useState<{
    filterState: string | null;
    search: string | null;
    grids: any[] | null;
  }>({
    filterState: "{}",
    search: "",
    grids: grids?.[0]?.gridId,
  });
  const [currentState, setCurrentState] = useState<{
    filterState: string | null;
    search: string | null;
    grids: any[] | null;
  }>({
    filterState: "{}",
    search: "",
    grids: grids?.[0]?.gridId,
  });

  const [excelDropdownVisible, setExcelDropdownVisible] = useState(false);
  const [isSampleLinkUnderlined, setIsSampleLinkUnderlined] = useState(false);
  const [excelUpload, setExcelUpload] = useState<ExcelUploadState>(initialExcelUploadState);

  const profileDetails = useSelector((state: RootState) => state.userProfile.profile);
  const sortState = useSelector((state: RootState) => state.dataTable.sortState);
  const setCurrentPage = (page: number) => {
    dispatch(updateCurrentPageSez(page));
  };



  const selectedConfigId = useSelector((state: RootState) => state.dataTable.selectedConfigId);
  const selectedTopSearchFilter = useSelector(
    (state: RootState) => state.navbarTop.selectedTopSearchFilter
  );
  const searchInputValue = useSelector((state: RootState) => state.navbarTop.searchInputValue);
  const topSearchState = useSelector((state: RootState) => state.navbarTop.userTopSearchState);

  const dataCountry = useDataCountry();
  const linerId = useSelector((state: RootState) => state.navbarTop.linerId);
  const language = useSelector((state: RootState) => state.navbarTop.language);
  const showColumnSettings = useSelector((state: RootState) => state.sezDashboard.showColumnSettings);
  const rbac = useSelector((state: RootState) => state.userProfile);

  function useDebouncedEffect(effect: any, deps: any, delay: any) {
    const callback = useRef<any>();

    useEffect(() => {
      callback.current = effect;
    }, [effect]);

    useEffect(() => {
      const handler = () => {
        if (callback.current) {
          callback.current();
        }
      };

      const timer = setTimeout(handler, delay);

      return () => clearTimeout(timer);
    }, [...deps, delay]);
  }
  const generateColumnConfig = useGenerateColumnConfig();


  const getParams = () => {
    const certificateValue = sez_cert_req_id || blid || bl_no || "";
    const decrypted = certificateValue ? AESDecrypt(certificateValue) : "";

    return {
      blid: decrypted,
      bl_no: decrypted,
      sez_cert_req_id: decrypted,
      pmtmode: decrypted,
    };
  };

  const parseColumnConfigGrid = (raw: string) => {
    let parsed = JSON.parse(raw);
    if (typeof parsed === "string") {
      parsed = JSON.parse(parsed);
    }
    return parsed;
  };

  useEffect(() => {
    const sezDashboardDefinition = grids?.[0]?.columnConfigGrid || "";

    if (!sezDashboardDefinition) return;

    try {
      const configs = generateColumnConfig(parseColumnConfigGrid(sezDashboardDefinition), getParams);

      const columns = configs?.columns?.map((c) => {
        const accessor = String(c?.accessor || "").toLowerCase();
        if (accessor !== "pending_since" && accessor !== "pendingsince") {
          return c;
        }

        return {
          ...c,
          Cell: (rowData: any) => {
            const row = rowData?.row?.original || {};
            const status = String(row?.status || "").toUpperCase();
            if (status === "APPROVED") {
              return "-";
            }
            const rawValue = row?.[c.accessor || ""] ?? rowData?.value;
            return formatPendingSinceDays(rawValue);
          },
        };
      });
      setConfigs(configs);
      setColumns(columns);
    } catch (e) {
      console.error("Column Error: ", e);
    }
  }, [grids, location]);

  useEffect(() => {
    dispatch(updateDashbaordName(gridName));
  }, []);

  const filterStateLocal = filterState?.[filterKey];
  const sort = (queryString.parse(location.search)?.sort as string)?.split?.(",")?.join?.(" ");

  useEffect(() => {
    if (location?.pathname && dataCountry && linerId) {
      dispatch(
        getColumnViews({
          gridName: dashboardName,
          country: dataCountry,
          linerId: linerId,
          language: language || localStorage.getItem('selectedLanguage') || 'EN',
        })
      );
    }
    dispatch(updateParams({}));
  }, [dataCountry, linerId, language]);

  useEffect(() => {
    loadSezDashboard(false);
  }, [currentPage]);

  useEffect(() => {
    if (refresh) loadSezDashboard(false);
  }, [refresh]);

  useEffect(() => {
    if (matchPath(location.pathname.toLowerCase(), "/sezdashboard")) loadSezDashboard(false);
  }, [location.pathname]);

  useEffect(() => {
    const currentState = {
      filterState: JSON.stringify(filterStateLocal),
      search: location.search,
      grids: grids?.[0]?.gridId,
    };
    if (JSON.stringify(previousState) !== JSON.stringify(currentState)) {
      setCurrentState({
        filterState: JSON.stringify(filterStateLocal),
        search: location.search,
        grids: grids?.[0]?.gridId,
      });
    }
  }, [filterStateLocal, location.search, grids]);

  useDebouncedEffect(
    () => {
      if (JSON.stringify(previousState) !== JSON.stringify(currentState)) {
        loadSezDashboard(true);
        setPreviousState(currentState);
      }
    },
    [currentState, linerId, language],
    700
  );

  useEffect(() => {
    loadSezDashboard(true);
  }, [linerId, language]);


  const buildSorts = () => {
    if (sortState && sortState?.key != null && sortState?.value != null) {
      return [`${sortState?.key} ${sortState?.value}`];
    }
    return sort ? [sort] : [defaultSort];
  };


  const dispatchDashboardData = (filters: any, parameter: any, filterUpdated: boolean) => {


    setTimeout(() => {
      dispatch(
        getDashboardData({
          gridName: gridName,
          payload: {
            fields: [],
            filters,
            size: 20,
            sorts: buildSorts(),
            page: filterUpdated ? 1 : currentPage,
          },
          dataCountry: dataCountry,
            partnerId: profileDetails.partnerId,
            partnerName: profileDetails.partnerName,
          where: grids?.[0]?.whereClause ? AESEncrypt(grids?.[0]?.whereClause) : null,
          parameter,
        })
      );
    }, 250);
  };

  const loadSezDashboard = (filterUpdated: boolean) => {
    if (filterUpdated) setCurrentPage(1);

    if (filterStateLocal && Object.keys(filterStateLocal)?.length > 0) {
      const filterApiState: any = {};
      const filterKeys = Object.keys(filterStateLocal);

      for (let k of filterKeys) {
        if (filterStateLocal?.[k]?.from) {
          filterApiState[k] = [filterStateLocal?.[k]?.from || "", filterStateLocal?.[k]?.to || ""].filter(
            (i) => i
          );
        } else if (filterStateLocal?.[k]?.from !== undefined) {
          filterApiState[k] = undefined;
        } else {
          filterApiState[k] = filterStateLocal?.[k]
            ? typeof filterStateLocal?.[k] === "string"
              ? [filterStateLocal?.[k]]
              : filterStateLocal?.[k]
            : undefined;
        }
      }

      if (Object.keys(filterApiState)?.length > 0) {
        const finalFilterApiState: any = {};

        if (grids[0]) {
          let timeFlag = "";
          let dateRange: any = {};

          const newdata = grids[0].configGroup?.find(
            (c: any) => c.userGridId == selectedConfigId?.[filterKey]
          )?.columnConfigGrid;
          if (newdata) {
            timeFlag = JSON.parse(newdata).find((item: any) => item.accessor == "invdt")?.filterState;
            dateRange = JSON.parse(newdata).find((item: any) => item.accessor == "invdt")?.dateRange;
          }
          if (filterApiState.invdt && timeFlag == "day" && dateRange) {
            filterApiState.invdt[1] = moment()
              .subtract(Math.abs(dateRange.to), "days")
              .endOf("day")
              .toISOString();
            filterApiState.invdt[0] = moment()
              .subtract(Math.abs(dateRange.from), "days")
              .startOf("day")
              .toISOString();
          }
        }
        for (let i of Object.keys(filterApiState)) {
          if (filterApiState[i]) {
            finalFilterApiState[i] = filterApiState[i];
          }
        }

        const filters =
          !selectedTopSearchFilter || selectedTopSearchFilter?.where == "" || searchInputValue.trim() === ""
            ? finalFilterApiState
            : {};
        const parameter =
          selectedTopSearchFilter?.where !== "" && searchInputValue.trim() !== ""
            ? { searchParameter: searchInputValue, searchWhere: selectedTopSearchFilter?.where }
            : {};

        dispatchDashboardData(filters, parameter, filterUpdated);
      }
      return;
    }

    const canRunEmptyFilterQuery =
      filterStateLocal ||
      (location.pathname.toLowerCase().includes("/sezdashboard") && location?.state?.from == undefined);

    if (!canRunEmptyFilterQuery) return;

    const filters = selectedTopSearchFilter?.where === "" ? topSearchState : {};
    const parameter =
      selectedTopSearchFilter?.where !== ""
        ? { searchParameter: searchInputValue, searchWhere: selectedTopSearchFilter?.where }
        : {};

    dispatchDashboardData(filters, parameter, filterUpdated);
  };

  useEffect(() => {
    dispatch(updateParams({}));
    dispatch(
      updateSortStateDataTable({
        key: null,
      })
    );
  }, [dataCountry]);

  const pathnameLower = location.pathname.toLowerCase();

  const certificateMatch = matchPath(
    { path: "/sezdashboard/certificate/:sez_cert_req_id", end: true },
    pathnameLower
  );
  const reviewMatch = matchPath("/sezdashboard/certificate/:sez_cert_req_id/review", pathnameLower);
  const historyMatch = matchPath("/sezdashboard/history/:sez_cert_req_id", pathnameLower);
  const isCertificatePath = !!certificateMatch;
  const isReviewPath = !!reviewMatch;
  const isHistoryPath = !!historyMatch;

  const sideWidth =
    Object.entries({
      [`/sezdashboard`]: 0,
      [`/sezdashboard/certificate/:sez_cert_req_id/review`]: 8,
      [`/sezdashboard/certificate/:sez_cert_req_id`]: 8,
      [`/sezdashboard/history/:sez_cert_req_id`]: 8,
    }).find(([path, _]) => matchPath(path, pathnameLower))?.[1] ?? 0;


  const isSliderOpen = isCertificatePath || isReviewPath || isHistoryPath;

  const resetExcelUploadState = () => {
    setExcelUpload(initialExcelUploadState);
  };

  const charLimit = (name: string, limit: number) =>
    name && name.length >= limit ? `${name.substring(0, limit)}...` : name;

  const handleExcelFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const ext = file.name.split(".").pop()?.toLowerCase();
    if (!ext || !["xlsx", "xls"].includes(ext)) {
      toast.error("Please select a valid XLSX/XLS file.");
      event.target.value = "";
      return;
    }

    if (file.size > 10 * 1024 * 1024) {
      toast.error("File size is greater than 10MB. Please upload file below 10MB");
      event.target.value = "";
      return;
    }

    if (file.name.length > 70) {
      toast.error("File name should not exceed 60 characters");
      event.target.value = "";
      return;
    }

    setExcelUpload((prev) => ({
      ...prev,
      fileName: file.name,
      uploadedFile: null,
      loadingProgress: 0,
    }));

    const formData = new FormData();
    formData.append("file", file);

    axios
      .post("/api/edo-rest-v1/v1/view/file", formData, {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress(progressEvent) {
          const percentCompleted = Math.round((progressEvent.loaded * 99) / (progressEvent.total ?? 1));
          setExcelUpload((prev) => ({ ...prev, loadingProgress: percentCompleted }));
        },
      })
      .then((response) => {
        setExcelUpload((prev) => ({
          ...prev,
          loadingProgress: 100,
          uploadedFile: {
            fileName: file.name,
            serverFileName: response.data.tempFileName,
            serverFilePath: response.data.path,
          },
        }));
      })
      .catch(() => {
        setExcelUpload((prev) => ({ ...prev, loadingProgress: -1, uploadedFile: null }));
        toast.error("File upload failed");
      })
      .finally(() => {
        event.target.value = "";
      });
  };

  const handleExcelSubmit = async () => {
    if (!excelUpload.uploadedFile) {
      toast.error("Please upload a file before submitting");
      return;
    }

    setExcelUpload((prev) => ({ ...prev, submitting: true }));
    try {
      const result = await dispatch(
        uploadSezCertificateExcel({
          fileName: excelUpload.uploadedFile.fileName,
          serverFileName: excelUpload.uploadedFile.serverFileName,
          serverFilePath: excelUpload.uploadedFile.serverFilePath,
          status: "Saved",
        })
      ).unwrap();

      if (result.status === "VALIDATION_FAILED") {
        toast.error(
          result.message ||
            "Some or all rows failed validation. Download the error file, correct the data, and re-upload."
        );
        if (result.errorFileUrl) {
          window.open(result.errorFileUrl, "_blank", "noopener,noreferrer");
        }
        return;
      }

      await dispatch(getInvoiceUploadHistory()).unwrap();
      toast.success(result.message || "SEZ Invoice uploaded successfully", {
        style: { color: "white" },
      });
      dispatch(updateDashbaordRefresh(true));
      resetExcelUploadState();
      setExcelDropdownVisible(false);
    } catch (e) {
      toast.error(getSezRejectedMessage(e, "Failed to upload SEZ Invoice"));
    } finally {
      setExcelUpload((prev) => ({ ...prev, submitting: false }));
    }
  };

  const sezUploadChild =
    !isSliderOpen && rbac.rbacDetails.sezInvoiceUpload === "Y" ? (
      <Dropdown
        navbar={true}
        style={{
          marginRight: "0.5rem",
          position: "relative",
          float: "left",
        }}
        onClick={() => setExcelDropdownVisible(true)}
        onToggle={(isOpen) => {
          setExcelDropdownVisible(isOpen);
          if (!isOpen) {
            resetExcelUploadState();
          }
        }}
        show={excelDropdownVisible}
      >
        <Dropdown.Toggle bsPrefix="toggle" as={Link} to="" className="nav-link">
          <Button
            variant="falcon-primary"
            size="sm"
            className="d-flex align-items-center"
            style={{ width: "max-content" }}
            title="Invoice Excel Upload"
            onClick={() => {
              resetExcelUploadState();
            }}
          >
            <FontAwesomeIcon
              icon={faPlus}
              style={{
                fontSize: "14px",
                color: "#f5822a",
                marginRight: "0.5rem",
              }}
            />
            <span>Excel Upload</span>
          </Button>
        </Dropdown.Toggle>

        {excelDropdownVisible && (
          <Dropdown.Menu
            className="dropdown-caret dropdown-menu-card dropdown-menu-end"
            style={{ minHeight: "90px" }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="row g-2 align-items-sm-center">
              <div className="col">
                <div className="row align-items-center">
                  <div className="col">
                    <span
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                      className="fs-0 text-primary"
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <label
                          className="btn btn-sm btn-falcon-primary"
                          style={{
                            marginBottom: "0rem",
                            margin: "0.5rem",
                          }}
                          htmlFor="sezExcelFileInput"
                        >
                          <FontAwesomeIcon
                            icon={faUpload}
                            className="me-2"
                            style={{
                              fontSize: "16px",
                              color: "#f5822a",
                              marginLeft: "0.5rem",
                              cursor: "pointer",
                            }}
                            title="Upload"
                          />
                        </label>
                        <input
                          type="file"
                          id="sezExcelFileInput"
                          accept=".xlsx,.xls"
                          onClick={(event: any) => {
                            event.target.value = "";
                            setExcelUpload((prev) => ({
                              ...prev,
                              fileName: "Upload File",
                              uploadedFile: null,
                              loadingProgress: null,
                            }));
                          }}
                          onChange={handleExcelFileChange}
                          style={{ display: "none" }}
                        />
                        <span
                          style={{
                            fontSize: "14px",
                            color: "#2c7be5",
                            fontWeight: 600,
                          }}
                        >
                          {charLimit(excelUpload.fileName, 15)}
                        </span>
                        {excelUpload.loadingProgress != null && (
                          <UploadIndicator
                            style={{ marginLeft: "10px" }}
                            progress={excelUpload.loadingProgress}
                            fail={excelUpload.loadingProgress === -1}
                          />
                        )}
                      </div>

                      {excelUpload.loadingProgress === 100 && (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Button
                            onClick={handleExcelSubmit}
                            className="me-2"
                            variant="falcon-primary"
                            size="sm"
                            style={{ margin: "0.5rem" }}
                            disabled={excelUpload.submitting || !excelUpload.uploadedFile}
                          >
                            {excelUpload.submitting ? "Submitting…" : "Submit"}
                          </Button>
                        </div>
                      )}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <Dropdown.Divider />
            <div style={{ width: "23rem" }} className="row g-2 align-items-sm-center">
              <div
                className="col"
                style={{
                  marginTop: "0.5rem",
                  marginLeft: "2rem",
                  marginBottom: "0.5rem",
                }}
              >
                <span
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    downloadSezInvoiceTemplate();
                  }}
                  onMouseEnter={() => setIsSampleLinkUnderlined(true)}
                  onMouseLeave={() => setIsSampleLinkUnderlined(false)}
                  style={{
                    color: "#2c7be5",
                    cursor: "pointer",
                    textDecoration: isSampleLinkUnderlined ? "underline" : "none",
                    fontStyle: "italic",
                    fontSize: "0.85rem",
                  }}
                >
                  Click here to download the sample excel format
                </span>
              </div>
            </div>
          </Dropdown.Menu>
        )}
      </Dropdown>
    ) : null;

  return (
    <DashboardContainer sideWidth={sideWidth}>
      <FilterView
        loadList={loadSezDashboard}
        showUploadButton
        showColumnSettings
        dataLoading={dataLoading}
        showExport={true}
        toggleColumnSettings={toggleColumnSettingsSezDash}
        columnSettingsPersistKey="@odex/sezDash/v1"
        uniqueFilterKey={filterKey}
        configViews={grids?.find?.((g) => g?.gridName === dashboardName)?.configGroup || []}
        showRightDiv={!!matchPath(pathnameLower, "/sezdashboard")}
        dashboardName={dashboardName}
        data={data}
        gridDef={grids}
        child={sezUploadChild}
      />
      {columns?.length > 0 && (
        <DataTable
          key={`sez-${grids?.[0]?.gridId}-${columns.length}`}
          data={data?.result || null}
          columns={columns}
          dataCountry={dataCountry || ""}
          sortable
          searchable={false}
          showColumnFilter
          selection={false}
          perPage={20}
          pagination
          numberPagination
          maxPage={parseInt(data?.maxPage || "100")}
          hasNext={data?.hasNext}
          currentPage={currentPage}
          gridId={grids?.[0]?.gridId || 0}
          onChangePageNumber={(pageNumber) => setCurrentPage(pageNumber)}
          showExport={false}
          showColumnSettings={showColumnSettings}
          onHide={() => {
            dispatch(toggleColumnSettingsSezDash(false));
          }}
          columnSettingsPersistKey="@odex/sezDash/v1"
          customSort={false}
          uniqueFilterKey={filterKey}
          staticHiddenCols={configs?.staticHiddenCols || []}
          defaultHiddenCols={[]}
          tableMinHeight={400}
          gridName={dashboardName}
          dataLoading={dataLoading}
          configGroup={grids?.[0]?.configGroup || []}
        />
      )}
    </DashboardContainer>
  );
};

export default SezDashboard;